import { render, staticRenderFns } from "./pattern.vue?vue&type=template&id=3b0aa11f&scoped=true"
import script from "./pattern.vue?vue&type=script&lang=js"
export * from "./pattern.vue?vue&type=script&lang=js"
import style0 from "./pattern.vue?vue&type=style&index=0&id=3b0aa11f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0aa11f",
  null
  
)

export default component.exports